import React, { useEffect, useState } from "react";
import HeadLines from "../../CommonComponents/HeadLines";
import { mapIcons } from "../../WareHouse/constant";

const MapLegends = ({ show, setShow }) => {
  return (
    <div className="d-flex gap16 ">
      {mapIcons.map((item, index) => {
        return (
          <div className="d-flex align-items-center padding-bottom16">
            <img src={item.image} width={28} height={28} />
            <HeadLines
              text={item.label}
              className="padding-left4 font-weight500 letterSpacing05 colorDark9"
            />
          </div>
        );
      })}
    </div>
  );
};
export default MapLegends;
